import urljoin from "url-join";

const env: { development: boolean, production: boolean } = {
  development: "production" === "development",
  production: "production" === "production",
};

const google: { apiKey: string | undefined } = {
  apiKey: "AIzaSyCcdE49CrgHx3DZeqx3gmXg7VVwjrzNE7k",
};

const backend: {
  AUTH_URI: string | undefined,
  HTTP_URI: string|undefined,
  WS_URI: string | undefined } =
  {
    AUTH_URI: "https://4pf35nwlsj.execute-api.us-east-1.amazonaws.com/prod",
    HTTP_URI: urljoin("https://4pf35nwlsj.execute-api.us-east-1.amazonaws.com/prod" ?? "", "graphql"),
    WS_URI: "wss://65cx9ym9qg.execute-api.us-east-1.amazonaws.com/prod",
  };

export { env, backend, google };
